import { DatePickerRangeSelection } from "@dropbox/dig-components/date_picker";
import { sub } from "date-fns";
import { atom, useAtom } from "jotai";

// custom date picker range state and handlers
const now = new Date();
export const DEFAULT_CUSTOM_START_DATE = sub(now, { weeks: 1 });
export const DEFAULT_CUSTOM_END_DATE = now;
const lastUpdatedFilterCustomDateAtom = atom<DatePickerRangeSelection>([
  DEFAULT_CUSTOM_START_DATE,
  DEFAULT_CUSTOM_END_DATE,
]);

export const useLastUpdatedCustomFilter = () => {
  const [customDateRange, setCustomDateRange] = useAtom(
    lastUpdatedFilterCustomDateAtom,
  );

  const handleCustomDateRangeChange = (
    newCustomDateRange: DatePickerRangeSelection,
  ) => {
    setCustomDateRange(newCustomDateRange);
  };

  return {
    customDateRange,
    handleCustomDateRangeChange,
  };
};
